import { Button, ButtonProps } from "@mui/material";
import { useCheckPermission } from "commons/hooks/use-check-permission";
export type XButtonProps = ButtonProps & {
  accessPermission?: "all" | string[];
};
export const XButton = ({
  accessPermission = "all",
  ...props
}: XButtonProps) => {
  const { allowAccess } = useCheckPermission(accessPermission);
  return (
    <Button
      {...props}
      sx={{ ...props.sx, borderRadius: "100px", textTransform: "capitalize" }}
      // disableRipple
      // disableFocusRipple
      disableTouchRipple
      disableElevation
      disabled={props.disabled || !allowAccess}
    ></Button>
  );
};
